import type { IconData } from '@stacksjs/iconify-core'

export const flashlightOnF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m7.2 10.81l3.99 3.99l-6.65 6.65a1.88 1.88 0 0 1-2.66 0L.55 20.12a1.88 1.88 0 0 1 0-2.66zm.85-1.809a2.8 2.8 0 0 1 .654-1.024l3.151-3.15a.94.94 0 0 1 1.33 0l3.99 3.99a.94.94 0 0 1 0 1.33l-3.123 3.121a2.8 2.8 0 0 1-1.066.669zm8.714-1.925a.87.87 0 0 1 0-1.227l2.098-2.097a.868.868 0 0 1 1.227 1.227l-2.097 2.097a.87.87 0 0 1-1.228 0m1.573 1.394a.87.87 0 0 1 .614-1.063l1.956-.524a.868.868 0 0 1 .45 1.677l-1.957.524a.87.87 0 0 1-1.063-.614m-3.414-3.235a.87.87 0 0 1 0-1.227L17.02 1.91a.868.868 0 0 1 1.228 1.227L16.15 5.235a.87.87 0 0 1-1.228 0zM13.53 3.663a.87.87 0 0 1-.614-1.063L13.44.644a.868.868 0 0 1 1.677.449l-.524 1.956a.87.87 0 0 1-1.063.614\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default flashlightOnF
